// Generated code for Big.Domain.Enums.ProfessionalGroupType.
// Edit _Enum.tst to change the generated output.

export enum ProfessionalGroupType {
    onbekend = 0,
    artikel3 = 1,
    verklaringVanVakbekwaamheid = 2,
    artikel36A = 3,
    artikel34Skp = 4
}
(ProfessionalGroupType as any).name = 'ProfessionalGroupType';
